var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDoneIcon = function SvgDoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16A8 8 0 118 0a8 8 0 010 16zm4.207-11.112l-1.124-.769a.708.708 0 00-.962.167L7.063 8.533 5.37 7.383a.696.696 0 00-.957.161l-.79 1.098a.663.663 0 00.166.931l2.258 1.538.016.01 1.107.758a.706.706 0 00.962-.167l4.242-5.893a.654.654 0 00-.167-.931z"
  })));
};
export default SvgDoneIcon;